import axios from 'axios'
import store from '@/store'
import {
  needRefreshToken, getAuthHeaderValue, getRefreshToken, setAccessToken, removeRefreshToken, getAccessToken
} from '@/auth/utils'
import router from '@/router'

const baseURL = process.env.VUE_APP_API_ENDPOINT
const axiosIns = axios.create({ baseURL })

async function getValidToken(config) {
  return navigator.locks.request('auth_refresh_lock', async () => {
    if (!needRefreshToken()) {
      return getAccessToken()
    }

    try {
      const payload = { refresh: getRefreshToken() }
      return await axios.post(`${config.baseURL}auth/token/refresh/`, payload)
        .then(({ data }) => setAccessToken(data.access))
        .catch(e => {
          Promise.reject(e)
          removeRefreshToken()
          router.push({ name: 'auth-login' })
        })
    } catch (error) {
      console.error('Ошибка обновления токена', error)
      throw error
    }
  })
}

let refreshPromise = null
axiosIns.interceptors.request.use(
  async config => {
    if (config.withCredentials !== false && !config.basicAuth) {
      if (needRefreshToken()) {
        if (!refreshPromise) {
          refreshPromise = getValidToken(config)
            .finally(() => refreshPromise = null)
        }

        try {
          await refreshPromise
        } catch (error) {
          return Promise.reject(error)
        }
      }

      config.headers.common.Authorization = getAuthHeaderValue()
    }
    return config
  },
    e => Promise.reject(e)
)

axiosIns.interceptors.response.use(response => response, e => {
  if (e.response && e.response.status === 401) {
    store.dispatch('auth/logoutWithoutRequest')
  }
  return Promise.reject(e)
})

export default axiosIns
